import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hresh1x/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hresh1x/labels')
  },
  getIndex (searchParams) {
    let codempid = ''
    let dtestrt = ''
    let dteend = ''
    if (typeof searchParams !== 'undefined') {
      if (isMock) return generator(mocker.index())
      codempid = (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      dtestrt = (typeof searchParams.dtestrt !== 'undefined' ? searchParams.dtestrt : '')
      dteend = (typeof searchParams.dteend !== 'undefined' ? searchParams.dteend : '')
    } else {
      return generator({
        total: 0,
        rows: []
      })
    }
    return instance().get(endpoint + '/hresh1x/index?' + 'p_codempid_query=' + codempid + '&p_dtest=' + dtestrt + '&p_dteen=' + dteend)
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    const params = searchParams.codempid + '/' + searchParams.dteeffec.replace(/\//g, '') + '/' + searchParams.codpunsh
    return instance().get(endpoint + '/hresh1x/detail/' + params)
  }
}



// WEBPACK FOOTER //
// ./src/api/hresh1x/index.js